import { render, staticRenderFns } from "./CategoryCardMeta.vue?vue&type=template&id=07b18624&scoped=true"
import script from "./CategoryCardMeta.vue?vue&type=script&lang=ts"
export * from "./CategoryCardMeta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b18624",
  null
  
)

export default component.exports